import { render } from "./HistoryHeader.vue?vue&type=template&id=545e6ee6&scoped=true"
import script from "./HistoryHeader.vue?vue&type=script&lang=js"
export * from "./HistoryHeader.vue?vue&type=script&lang=js"

import "./HistoryHeader.vue?vue&type=style&index=0&id=545e6ee6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545e6ee6"]])

export default __exports__